import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || 'https://apim.tianyudaojia.com/api',
  timeout: 15000
})

// 防止重复弹窗的机制
let isShowingAuthError = false

// 获取cookie值的工具函数
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

// 设置cookie值的工具函数
function setCookie(name, value, days = 7) {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = getCookie('Java-merchantToken')
    if (token) {
      config.headers['authori-zation'] = token
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 根据实际API响应，成功响应的code为200
    if (res.code !== undefined && res.code !== 200) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 401: 未授权 - 只清除token，不自动刷新页面
      if (res.code === 401) {
        // 清除cookie中的token
        document.cookie = 'Java-merchantToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        // 移除自动刷新，避免死循环
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error)
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

// 导出cookie工具函数供其他模块使用
export { getCookie, setCookie }

export default service
